// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__1uPs8","partners":"styles_partners__xGZxG"};